import {
    addFormControlSelect2, fnToastrFormError, getSelectedCompany, printResponse,
    resetForm
} from "../jquery-functions-library";
import {element_exists} from "../functions";
import * as toastr from "toastr";

export var fnDashboardTaskTable = function () {

    var tableName = '#datatable-tasks';
    var modal = $('#modal-add-task');

    function checkFreq() {
        $('#odd-or-even-week-container').hide();
        $('#start-or-end-month-container').hide();

        if ($('#frequency').val() == 2) {
            $('#odd-or-even-week-container').show();
        }

        if ($('#frequency').val() == 4) {
            $('#start-or-end-month-container').show();
        }

        $("#frequency").off('change').on('change', function () {
            // selected biweekly
            if ($(this).val() == 2) {
                $('#odd-or-even-week-container').show();
            } else {
                $('#odd-or-even-week-container').hide();
            }

            // selected monthly
            if ($(this).val() == 4) {
                $('#start-or-end-month-container').show();
            } else {
                $('#start-or-end-month-container').hide();
            }
        });
    }

    $('#task_responsible_ids').select2({width: '271px', height: '75%'}).addClass('form-control');

    $('#task_responsible_ids').on('select2:select', function (e) {
        let data = e.params.data;

        let element = $(this);

        if (data.id === 'null') {
            element.val(data.id);
            element.trigger('change');
        } else {
            let values = $('#task_responsible_ids').val();
            if (values.indexOf('null') !== -1) {
                values.splice(values.indexOf('null'), 1);
            }
            element.val(values);
            element.trigger('change');

        }
    });

    addFormControlSelect2();

    if (!element_exists(tableName)) return false;

    $('#datatable-tasks tbody').off('click', 'tr');
    $('#datatable-tasks tbody').on('click', 'tr', function () {
        const tableData = table.row(this).data();
        $('#task_title').val(tableData.task_title);
        $('#task_description').val(tableData.task_description);
        $('#task_id').val(tableData.task_id);

        const $weekdaysSelects = $('.weekdays-select');
        $.each($weekdaysSelects, function ($weekdaysSelectKey, weekdaysSelect) {
            const $weekdaysSelect = $(weekdaysSelect);
            if (!$weekdaysSelect.data('select2')) {
                $weekdaysSelect.select2();
                $weekdaysSelect.css({width: '100% !important'});
            }

            $weekdaysSelect.val([]).trigger('change');
            $weekdaysSelect.val(tableData.weekdaysData).trigger('change');
        });

        //notification
        $('#send_notification').prop('checked', tableData.send_notification);

        $('#frequency').val(tableData.notification_recurring_week);
        $('#odd-or-even-week').val(tableData.notification_recurring_even_week);
        $('#start-or-end-month').val(tableData.notification_recurring_start_of_month);

        checkFreq();

        $.ajax({
            type: 'GET',
            url: '/task-templates/responsible-employees/filtered',
            success: function (responsible) {
                $('#task_responsible_ids').html(responsible);
                if (tableData.responsible_ids) {
                    $('#task_responsible_ids').val(tableData.responsible_ids.split(', '));
                } else {
                    $('#task_responsible_ids').val("null")
                }
                $('#task_responsible_ids').trigger('change');
            },
            error: function (response) {

            }
        });

        var date = tableData.deadline;
        var dateArray = date.split('-');
        var newDate = '20' + dateArray[2] + '-' + dateArray[1] + '-' + dateArray[0];
        $('#task_deadline').val(newDate);
        $('#vouchers').html('');
        $("#task_status option").each(function () {
            if ($(this).html() == tableData.status) {
                $(this).prop("selected", true);
                return;
            }
        });
        var task_id = tableData.task_id;
        $.ajax({
            type: 'POST',
            url: '/getTaskVouchers',
            data: {
                task_id: task_id,
            },
            success: function (response) {
                $.each(response, function (index, value) {
                    var deleteBtn = '<button class="btn btn-fa btn-danger btn-sm btn-delete-image" data-id="' + response[index]['task_voucher_id'] + '" type="button"><i class="fa fa-times-circle fa-2x"></i></button>';
                    var fileExtension = ['jpeg', 'jpg', 'png', 'gif', 'bmp'];
                    if ($.inArray(response[index]['filename'].split('.').pop().toLowerCase(), fileExtension) == 1) {
                        $('#vouchers').append('<div class="task-image-container"><img width="200" src="/uploads/' + response[index]['filename'] + '" data-action="zoom"/><br/>' + deleteBtn + '</div>');
                    } else {
                        $('#vouchers').append('<div class="task-image-container"><form method="get" action="/uploads/' + response[index]['filename'] + '" target="_blank"><button class="btn btn-success">' + response[index]['filename'] + '</button></form><br/>' + deleteBtn + '</div>');
                    }
                });
            },
            error: fnToastrFormError,
        })

        $('#delete-tasks').removeClass('hidden');
        $('#update-tasks').removeClass('hidden');
        $('#submit-tasks').addClass('hidden');
        modal.modal('show');
    });

    $(document).off('click', '.btn-delete-image').on('click', '.btn-delete-image', function (e) {
        e.preventDefault();

        var id = $(this).data('id');
        var container = $(this).parents('.task-image-container');

        $.confirm({
            title: allLangFiles.forms.delete,
            content: allLangFiles.forms.delete + ' img',
            theme: 'supervan',
            columnClass: 'col-md-12',
            backgroundDismiss: true,
            buttons: {
                Ja: {
                    action: function () {

                        $.ajax({
                            type: 'DELETE',
                            url: '/tasks/delete/' + id,
                            success: function (response) {
                                container.remove();
                            },
                            error: function (error) {
                                fnToastrFormError(error);
                                modal.modal('hide');
                            }
                        });
                    },
                    text: allLangFiles.users.js.yes
                },
                Nej: {
                    text: allLangFiles.users.js.no
                }
            }
        });
    });

    $('#add_task').off('click').on('click', function () {

        $.ajax({
            type: 'GET',
            url: '/task-templates/responsible-employees/filtered',
            success: function (responsible) {
                $('#task_responsible_ids').html(responsible);
            },
            error: function (response) {

            }
        });

        const $weekdaysSelect = $('.weekdays-select');
        if (!$weekdaysSelect.data('select2')) {
            $weekdaysSelect.select2();
            $weekdaysSelect.css({width: '100% !important'});
        }
        $weekdaysSelect.val([]).trigger('change');

        checkFreq();

        $('#vouchers').html('');
        $('#delete-tasks').addClass('hidden');
        $('#update-tasks').addClass('hidden');
        $('#submit-tasks').removeClass('hidden');
        $('#send_notification').prop('checked', false);
    });

    $('#add-task-form').off('submit').on('submit', function (e) {
        e.preventDefault();

        var lang = allLangFiles['task-templates'];
        var selectedName = $('#task_responsible_ids').find('option:selected').html();
        var confirmMessage = lang.responsible_selected_first + ' ' + selectedName + ' ' + lang.responsible_selected_second;
        var self = this;

        $.confirm({
            title: allLangFiles.forms.create,
            content: confirmMessage + '.<br><br>' + lang.no_notifications,
            theme: 'supervan',
            columnClass: 'col-md-12',
            backgroundDismiss: true,
            buttons: {
                Ja: {
                    action: function () {
                        var selectedCompanyId = getSelectedCompany();
                        $('#current_company_id').val(selectedCompanyId);
                        var formData = new FormData($(self)[0]);

                        formData.append('send_notification', $('#send_notification').prop("checked"));
                        formData.append('notification_recurring_week', $('#frequency').val());
                        let responsibleIds = $('#task_responsible_ids').val();
                        formData.append('responsible_ids', JSON.stringify(responsibleIds ? responsibleIds : []));

                        $.ajax({
                            type: 'POST',
                            url: '/addTask',
                            mimeType: "multipart/form-data",
                            data: formData,
                            success: function (response) {
                                modal.modal('hide');
                            },
                            cache: false,
                            processData: false,
                            contentType: false,
                            error: function (response) {
                                if (response.status === 422) {
                                    var data = JSON.parse(response.responseText);
                                    for (var error in data.errors) {
                                        toastr.error(data.errors[error][0]);
                                    }
                                }
                            },
                        })

                    },
                    text: allLangFiles.users.js.yes
                },
                Nej: {
                    text: allLangFiles.users.js.no
                }
            }
        });
    });

    modal.off().on('hidden.bs.modal', function () {
        resetForm($('#add-task-form'));
        $(tableName).DataTable().ajax.reload(null, false);
    });

    var columns = [
        {data: 'task_title'},
        {data: 'task_description'},
        {data: 'status'},
        {data: 'deadline'},
        {data: 'weekdays'},
        {data: 'task_responsible_names'},
        {data: 'task_responsible_ids'},
    ];

    /*Rules for filling the columns*/
    var columnDefs = [
        {className: "p-l-10", targets: 0},
        {className: "p-l-10", targets: 1},
        {className: "p-l-10", targets: 2},
        {className: "p-l-10", targets: 3},
        {className: "p-l-10", targets: 4},
        {className: "p-l-10", targets: 5},
        {className: "p-l-10", targets: 6, visible: false},
    ];

    /*Important otherwise table misaligned*/
    $(tableName).css('width', '100%');
    var table = $(tableName).DataTable({
        // language: {
        //     url: '/language/datatables'
        // },
        language: allLangFiles.datatables,
        ajax: {
            url: '/getTasks',
        },
        columns: columns,
        columnDefs: columnDefs,
        bFilter: false,
        destroy: true,
        pageLength: -1,
        dom: 'frtipB',
        buttons: [
            'copy', 'csv', 'excel', 'pdf', 'print'
        ],
        bInfo: false,
        bLengthChange: false,
        scrollX: true,
        lengthMenu: [10, 25, 50, 75, 100],
        initComplete: function (settings, json) {
            table.draw();
        },
    });

    $('#delete-tasks').off('click').on('click', function (e) {
        e.preventDefault();

        $.confirm({
            title: allLangFiles.forms.delete,
            content: allLangFiles.forms.delete,
            theme: 'supervan',
            columnClass: 'col-md-12',
            backgroundDismiss: true,
            buttons: {
                Ja: {
                    action: function () {

                        var task_id = $('#task_id').val();

                        $.ajax({
                            type: 'POST',
                            url: '/deleteTask',
                            data: {
                                task_id: task_id,
                            },
                            success: function (response) {
                                $(tableName).DataTable().ajax.reload(null, false);
                                modal.modal('hide');
                            },
                            error: fnToastrFormError,
                        })

                    },
                    text: allLangFiles.users.js.yes
                },
                Nej: {
                    text: allLangFiles.users.js.no
                }
            }
        });
    });

    $('#update-tasks').off('click').on('click', function (e) {
        e.preventDefault();
        var lang = allLangFiles['task-templates'];

        var selectedName = $('#task_responsible_ids').find('option:selected').html();
        var confirmMessage = lang.responsible_selected_first + ' ' + selectedName + ' ' + lang.responsible_selected_second;

        $.confirm({
            title: allLangFiles.forms.update,
            content: confirmMessage + '.<br><br>' + lang.no_notifications,
            theme: 'supervan',
            columnClass: 'col-md-12',
            backgroundDismiss: true,
            buttons: {
                Ja: {
                    action: function () {
                        var formData = new FormData($('#add-task-form')[0]);

                        formData.append('send_notification', $('#send_notification').prop("checked"));
                        formData.append('notification_recurring_week', $('#frequency').val());
                        formData.append('notification_recurring_even_week', $('#odd-or-even-week').val());
                        formData.append('notification_recurring_start_of_month', $('#start-or-end-month').val());

                        let responsibleIds = $('#task_responsible_ids').val();
                        formData.append('responsible_ids', JSON.stringify(responsibleIds ? responsibleIds : []));

                        $.ajax({
                            type: 'POST',
                            url: '/updateTask',
                            mimeType: "multipart/form-data",
                            contentType: false,
                            processData: false,
                            data: formData,
                            success: function (response) {
                                $(tableName).DataTable().ajax.reload(null, false);
                                modal.modal('hide');
                            },
                            error: function (response) {
                                if(response.status === 403){
                                    toastr.error(allLangFiles.forms.unauthorized);
                                    modal.modal('hide');
                                }
                                if (response.status === 422) {
                                    var data = JSON.parse(response.responseText);
                                    for (var error in data.errors) {
                                        toastr.error(data.errors[error][0]);
                                    }
                                }
                            },
                        })

                    },
                    text: allLangFiles.users.js.yes
                },
                Nej: {
                    text: allLangFiles.users.js.no
                }
            }
        });
    });

    $(document).off('click', '#add_tasks_from_template').on('click', '#add_tasks_from_template', function (e) {
        e.preventDefault();
        var url = $(this).attr('data-href');
        var modalName = '#modal-add-tasks-from-template';

        if (!element_exists(modalName)) {

            $.ajax({
                url: url,
                success: function (response) {

                    $('.dynamic-modal-container').append(response);

                    var modal = $(modalName);

                    modal.modal('show');

                    var form = $('#form-create-tasks-from-template');

                    form.off('submit').on('submit', function (e) {
                        e.preventDefault();

                        var formData = $(this).serialize();
                        var url = this.action;

                        $.ajax({
                            type: 'POST',
                            url: url,
                            data: formData,
                            success: function (response) {
                                if (!response.error) {
                                    modal.modal('hide');
                                    $(tableName).DataTable().ajax.reload(null, false);
                                }
                                printResponse(response);
                            },
                        })
                    });
                    modal.on('hidden.bs.modal', function () {
                        modal.remove();
                    });
                }
            });
        }
    })
};
